export enum RealEstateObjectStateEnum {
  activationPending = 'ActivationPending',
  notVisible = 'NotVisible',
  visible = 'Visible'
}
